/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Nessuna menzione'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Hai menzionato Prozis in una storia su Instagram il {publishedAt}',
    NO_ROWS_MENTIONS: 'Non hai ancora menzionato Prozis sul tuo instagram'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
